// for aNextStep()
const nextStepCallBacks = {
	// begin cb if it's input sheet.
	beforeRequestNext($form) {},
	
	// success cb if it's input sheet. (before focus the next sheet.)
	beforeFocusNext(response) {},
	
	// success cb if it's input sheet. (after focus the next sheet.)
	afterFocusNext() {},
	
	// begin cb if it's confirm sheet.
	beforeRequestEdit($form) {},
	
	// success cb if it's confirm sheet.
	editedResponce(response) {}
};

export default nextStepCallBacks;
